import { getLangText } from 'utils/langText';

export const showQuestionModal = (changes, categoriesList) => {
  const categoryName = getLangText(changes?.nameLang?.value);
  if (
    categoryName &&
    categoryName.length > 0 &&
    categoriesList.some((category) => category.name.toLowerCase() === categoryName.toLowerCase())
  ) {
    return true;
  }
  return false;
};
